'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true,
});

var _index = require('../../../_lib/buildLocalizeFn/index.js');

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) {
	return obj && obj.__esModule ? obj : { default: obj };
}

var eraValues = {
	narrow: ['f.Kr.', 'e.Kr.'],
	abbreviated: ['f.Kr.', 'e.Kr.'],
	wide: ['før Kristus', 'etter Kristus'],
};

var quarterValues = {
	narrow: ['1', '2', '3', '4'],
	abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
	wide: ['1. kvartal', '2. kvartal', '3. kvartal', '4. kvartal'],
};

var monthValues = {
	narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
	abbreviated: [
		'jan.',
		'feb.',
		'mars',
		'apr.',
		'mai',
		'juni',
		'juli',
		'aug.',
		'sep.',
		'okt.',
		'nov.',
		'des.',
	],
	wide: [
		'januar',
		'februar',
		'mars',
		'april',
		'mai',
		'juni',
		'juli',
		'august',
		'september',
		'oktober',
		'november',
		'desember',
	],
};

var dayValues = {
	narrow: ['S', 'M', 'T', 'O', 'T', 'F', 'L'],
	short: ['su', 'må', 'ty', 'on', 'to', 'fr', 'la'],
	abbreviated: ['sun', 'mån', 'tys', 'ons', 'tor', 'fre', 'lau'],
	wide: [
		'sundag',
		'måndag ',
		'tysdag',
		'onsdag',
		'torsdag',
		'fredag',
		'laurdag',
	],
};

var dayPeriodValues = {
	narrow: {
		am: 'a',
		pm: 'p',
		midnight: 'midnatt',
		noon: 'middag',
		morning: 'på morg.',
		afternoon: 'på etterm.',
		evening: 'på kvelden',
		night: 'på natten',
	},
	abbreviated: {
		am: 'a.m.',
		pm: 'p.m.',
		midnight: 'midnatt',
		noon: 'middag',
		morning: 'på morg.',
		afternoon: 'på etterm.',
		evening: 'på kvelden',
		night: 'på natten',
	},
	wide: {
		am: 'a.m.',
		pm: 'p.m.',
		midnight: 'midnatt',
		noon: 'middag',
		morning: 'på morgenen',
		afternoon: 'på ettermiddagen',
		evening: 'på kvelden',
		night: 'på natten',
	},
};

function ordinalNumber(dirtyNumber) {
	var number = Number(dirtyNumber);
	return number + '.';
}

var localize = {
	ordinalNumber: ordinalNumber,

	era: (0, _index2.default)({
		values: eraValues,
		defaultWidth: 'wide',
	}),

	quarter: (0, _index2.default)({
		values: quarterValues,
		defaultWidth: 'wide',
		argumentCallback: function argumentCallback(quarter) {
			return Number(quarter) - 1;
		},
	}),

	month: (0, _index2.default)({
		values: monthValues,
		defaultWidth: 'wide',
	}),

	day: (0, _index2.default)({
		values: dayValues,
		defaultWidth: 'wide',
	}),

	dayPeriod: (0, _index2.default)({
		values: dayPeriodValues,
		defaultWidth: 'wide',
	}),
};

exports.default = localize;
module.exports = exports['default'];
